import CompaniesPage from "../components/pages/companies/CompaniesPage";
import CompanyCreatePage from "../components/pages/companies/CreateCompanyPage";

const routes = [
    {
        path: "/companies",
        element: <CompaniesPage />
    },
    {
        path: "/companies/create",
        element: <CompanyCreatePage />
    },
    {
        path: "/companies/edit/:companyID",
        element: <CompanyCreatePage />
    }
];

export default routes;
